import { useMemo } from "react";
import { useSearchParams } from "react-router";

import { getSortOptionFromURI } from "components/Filters/helpers";
import useSearchStacksForNavigation from "shared/Stack/useSearchStacksForNavigation";
import { makeStringEqualsPredicate } from "utils/predicates";
import { StackSuggestions } from "constants/stack";

import { INITIAL_SORT_DIRECTION, INITIAL_SORT_OPTION, ITEMS_LIMIT } from "./Table/constants";

const useSpaceliftVcsRepoUsedBySearchUsedStacks = (stackIDs: string[]) => {
  const skip = stackIDs.length === 0;
  const [searchParams] = useSearchParams();

  const predicates = useMemo(() => {
    if (skip) {
      return [];
    }

    return [makeStringEqualsPredicate(StackSuggestions.Slug, stackIDs)];
  }, [stackIDs, skip]);

  const sortOptionFields = useMemo(
    () => getSortOptionFromURI(searchParams, INITIAL_SORT_OPTION, INITIAL_SORT_DIRECTION),
    [searchParams]
  );

  return useSearchStacksForNavigation({
    predicates,
    orderBy: sortOptionFields,
    skip,
    first: ITEMS_LIMIT,
  });
};

export default useSpaceliftVcsRepoUsedBySearchUsedStacks;
